import { render } from "./NodeDeleteEditCellRenderer.vue?vue&type=template&id=5aa23938&scoped=true"
import script from "./NodeDeleteEditCellRenderer.vue?vue&type=script&lang=js"
export * from "./NodeDeleteEditCellRenderer.vue?vue&type=script&lang=js"

import "./NodeDeleteEditCellRenderer.vue?vue&type=style&index=0&id=5aa23938&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5aa23938"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
